import {
  ExcalidrawElement,
  ExcalidrawImageElement,
  FileId,
  InitializedExcalidrawImageElement,
  NonDeleted
} from "../element/types";
import { AppClassProperties, AppProps, AppState } from "../types";
import { register } from "./register";
import { KEYS } from "../keys";
import { ActionResult } from "./types";
import { selectGroupsForSelectedElements } from "../groups";
import { isBoundToContainer, isInitializedImageElement } from "../element/typeChecks";
import { getNonDeletedElements } from "../element";
import firebase from "firebase";
import { DuplicateIcon, ReplaceIcon } from "../components/icons";
import { t } from "../i18n";
import { getShortcutKey } from "../utils";
import { isSomeElementSelected } from "../scene";
import { ToolButton } from "../components/ToolButton";
import { fileOpen } from "../data/filesystem";
import { DEFAULT_MAX_IMAGE_WIDTH_OR_HEIGHT, IMAGE_MIME_TYPES, MAX_ALLOWED_FILE_BYTES, MIME_TYPES } from "../constants";
import {
  dataURLToFile,
  generateIdFromFile, getDataURL,
  isSupportedImageFile,
  resizeImageFile,
  SVGStringToFile
} from "../data/blob";
import { normalizeSVG } from "../element/image";
import { mutateElement } from "../element/mutateElement";
import {extFromMineType, imgPathPerfix} from "../../../../src/utils";
import {ipcInvoke} from "../../../../src/common/ipc";
import i18next from "i18next";
import {getCardById, updateCard} from "../../../../model";


export const actionReplaceSelection= register({
  name:"replaceSelection",
  trackEvent:{category:"element"},
  perform:(element,appState,formData,app)=>{
    return{
      ...replaceElement(element,appState,app),
      commitToHistory:true
    }
  },
  contextItemLabel:"labels.replaceSelection",
  PanelComponent:({elements,appState,updateData})=>(
    <ToolButton
      type="button"
      title={`${t("labels.replaceSelection")} — ${getShortcutKey(
        "CtrlOrCmd+R",
      )}`}
      aria-label={t("labels.replaceSelection")}
      onClick={() => updateData(null)}
      visible={isSomeElementSelected(getNonDeletedElements(elements), appState)}
    >
      <img src={imgPathPerfix()+'image_replace.png'} style={{width:'18px',height:'18px'}}/>
    </ToolButton>
  )
});

const replaceElement= async (
  elements:readonly ExcalidrawElement[],
  appState:AppState,
  app:AppClassProperties
) => {
  const imageFile = await fileOpen({
    description: "Image",
    extensions: Object.keys(
      IMAGE_MIME_TYPES,
    ) as (keyof typeof IMAGE_MIME_TYPES)[],
  });

  let imageElement:any=null;
  for (var i=0;i<elements.length;i++){
    var item = elements[i];
    if (item.type === "image"){
      if (appState.selectedElementIds[item.id] != undefined){
        imageElement = item;
        break;
      }
    }
  }
  const newImageElement = await initializeImage({imageFile,imageElement,app});

  return {
    elements:[newImageElement],
    appState: {
      ...appState
    }
  };
}

const initializeImage = async ({
                                   imageFile,
                                   imageElement: _imageElement,
                                    app
                                 }: {
  imageFile: File;
  imageElement: ExcalidrawImageElement;
  app:AppClassProperties
}) => {
  // at this point this should be guaranteed image file, but we do this check
  // to satisfy TS down the line
  if (!isSupportedImageFile(imageFile)) {
    throw new Error(t("errors.unsupportedFileType"));
  }
  const mimeType = imageFile.type;

  if (mimeType === MIME_TYPES.svg) {
    try {
      imageFile = SVGStringToFile(
        await normalizeSVG(await imageFile.text()),
        imageFile.name,
      );
    } catch (error: any) {
      console.warn(error);
      throw new Error(t("errors.svgImageInsertError"));
    }
  }

  // generate image id (by default the file digest) before any
  // resizing/compression takes place to keep it more portable
  const fileId = await (generateIdFromFile(imageFile));

  if (!fileId) {
    console.warn(
      "Couldn't generate file id or the supplied `generateIdForFile` didn't resolve to one.",
    );
    throw new Error(t("errors.imageInsertError"));
  }

  const existingFileData = undefined;//this.files[fileId];
  try {
    imageFile = await resizeImageFile(imageFile, {
      maxWidthOrHeight: DEFAULT_MAX_IMAGE_WIDTH_OR_HEIGHT,
    });
  } catch (error: any) {
    console.error(
      "Error trying to resizing image file on insertion",
      error,
    );
  }

  if (imageFile.size > MAX_ALLOWED_FILE_BYTES) {
    throw new Error(
        i18next.t("fileTooBig", {
        maxSize: `${Math.trunc(MAX_ALLOWED_FILE_BYTES / 1024 / 1024)}MB`,
      }),
    );
  }

  const dataURL = (await getDataURL(imageFile));
  const oldWidth = _imageElement.width;
  const oldHeight = _imageElement.height;
  const size:any = await getImageSize(dataURL);
  //新的图片大小，缩放到旧的图片大小。得到新的W,H
  const fRateW = oldWidth/size.width;
  const fRateH = oldHeight/size.height;
  const fMin = Math.min(fRateW,fRateH);

  const imageElement = mutateElement(
    _imageElement,
    {
      fileId,
      width:size.width*fMin,
      height:size.height*fMin
    },
    false,
  ) as NonDeleted<InitializedExcalidrawImageElement>;

  return new Promise<NonDeleted<InitializedExcalidrawImageElement>>(
    async (resolve, reject) => {
      try {
        var arrayFuckEx:any = [];
        var item = {
          mimeType: mimeType,
          id: fileId,
          dataURL: '',
          created:new Date().getTime()
        }
        const szFileName = fileId + "." + extFromMineType(mimeType);
        await ipcInvoke('write-base64-image',{fileName:szFileName,imgBase64:dataURL});
        arrayFuckEx.push(item);
        app.addFiles(arrayFuckEx);

        //如果在库里，要更改库里的图片.
        // const library:any = await getCardById(_imageElement.customData?.generationData?.id);
        // if (library){
        //   //删除之前的图片
        //   ipcInvoke('delete-files-file',{fileName:library.fileName})
        //   library.fileName = szFileName;
        //   await updateCard(library);
        // }

        resolve(imageElement);
      } catch (error: any) {
        console.error(error);
        reject(new Error(t("errors.imageInsertError")));
      } finally {

      }
    },
  );
};

function getImageSize(szBase64:string){
  const image = new Image();
  image.src = szBase64;
  return new Promise(((resolve, reject) => {
    image.onload = ()=>{
      const {width,height} = image;
      resolve({width,height});
    }
  }))
}
